import { render, staticRenderFns } from "./consume.vue?vue&type=template&id=1376354a&scoped=true&"
import script from "./consume.vue?vue&type=script&lang=js&"
export * from "./consume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1376354a",
  null
  
)

export default component.exports